import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/emergencyDriver/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}
/**
 * 获取应急司机下拉
 * @constructor
 */
export function FetchEmergencyDriverName() {
    return request({
        url: "/emergencyDriver/getEmergencyDriver",
        method: "post",
    });
}
/**
 * 获取应急企业下拉
 * @constructor
 */
export function FetchEmergencyComparyName() {
    return request({
        url: "/emergencyVehicle/getEmergencyComparyName",
        method: "post",
    });
}
